module.exports = __webpack_public_path__ + "img/ee.800c650f.svg";